export type CanonicalPaymentMethod =
  | 'stripe'
  | 'bank_transfer'
  | 'pix'
  | 'zelle'
  | 'cash'
  | 'check'
  | 'other';

export const PAYMENT_METHOD_LABEL: Record<string, string> = {
  stripe: 'Cartão (Stripe)',
  bank_transfer: 'Transferência bancária',
  pix: 'PIX',
  zelle: 'Zelle',
  cash: 'Dinheiro',
  check: 'Cheque',
  other: 'Outro',
  // Legacy aliases kept for display compatibility
  wire: 'Transferência bancária',
  credit_card: 'Cartão (Stripe)',
  debit_card: 'Cartão (Stripe)',
};

export const PAYMENT_METHOD_OPTIONS: Array<{ value: CanonicalPaymentMethod; label: string }> = [
  { value: 'stripe', label: PAYMENT_METHOD_LABEL.stripe },
  { value: 'bank_transfer', label: PAYMENT_METHOD_LABEL.bank_transfer },
  { value: 'pix', label: PAYMENT_METHOD_LABEL.pix },
  { value: 'zelle', label: PAYMENT_METHOD_LABEL.zelle },
  { value: 'cash', label: PAYMENT_METHOD_LABEL.cash },
  { value: 'check', label: PAYMENT_METHOD_LABEL.check },
  { value: 'other', label: PAYMENT_METHOD_LABEL.other },
];

export function normalizePaymentMethod(value?: string | null): CanonicalPaymentMethod | undefined {
  if (!value) return undefined;
  const normalized = value.toLowerCase();
  if (normalized === 'wire') return 'bank_transfer';
  if (normalized === 'credit_card' || normalized === 'debit_card') return 'stripe';
  if (
    normalized === 'stripe' ||
    normalized === 'bank_transfer' ||
    normalized === 'pix' ||
    normalized === 'zelle' ||
    normalized === 'cash' ||
    normalized === 'check' ||
    normalized === 'other'
  ) {
    return normalized;
  }
  return undefined;
}
